export default `
Noen barn bruker tid på å bli tørre hele natten. Det er ikke barnets feil, og skyldes ofte en for stor urinproduksjon om natten. Test om ditt barn vil bruke tid på å bli kvitt sengevætingen.
`



// WEBPACK FOOTER //
// ./src/containers/Home/text.js